import {Breadcrumb,Button} from 'react-bootstrap';
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const breadCrumbNavArray = [
  { pathTo: "/", pathName: "Your Info" },
  { pathTo: "/current-education", pathName: "Current Education" },
  { pathTo: "/family", pathName: "Family" },
  { pathTo: "/college-university-considering", pathName: "College/University Considering" },
  { pathTo: "/work-activities", pathName: "Work/Activities" },
  { pathTo: "/review", pathName: "Review" },
]
//counselor breadcrumb 
const counselorNavArray = [
  { pathTo: "/counselor", pathName: "Counselor/Academic Advisor" },
  { pathTo: "/counselor-review", pathName: "Review" },
  
]
//counselor thank you breadcrumb
const thankYouCounselorArray = [
  {pathTo: "/counselor/thank-you/", pathName: "Thank you" }
]
//student thank you breadcrumb
const thankYouStudentArray = [
  {pathTo: "/student/thank-you/", pathName: "Thank you" }
]

const Nav = (props) => {
  const {navbType} = props;
  let navBar = navbType==="student" ? breadCrumbNavArray :navbType==="counselor"? counselorNavArray:
  navbType==="thankYou"?thankYouStudentArray:thankYouCounselorArray;
  const location = useLocation(); 
  const [routeIndexNumber,setRouteIndex] = useState("");
  useEffect(()=>{
    let path = location.pathname;
    let routeIndex = navBar.findIndex((x) => x.pathTo === path)
    setRouteIndex(routeIndex);
  },[location.pathname,navBar])
  const renderLinkContainer = () => {
    return navBar.map(({ pathTo, pathName }, ind) => {
      return routeIndexNumber>ind ?
        <div className="navbarButtonActive" key={ind}>
          <Button variant="link" className="p-0" onClick={()=>{
           props.handleNavBack(pathTo)}}
          disabled={routeIndexNumber<=ind}>{pathName}</Button>
         {ind !== navBar.length-1 && <p className="navSlashColor">/</p>}
        </div>
        :
        routeIndexNumber===ind ? 
        <div className="navbarButtonActive" key={ind}>
        <Button variant="light" className="p-0 " style={{backgroundColor:"#e9ecef",border:"none"}} disabled>{pathName}</Button>
        {ind !== navBar.length-1 &&<p className="navSlashColor">/</p>}
        </div>:
        <div className="navbarButtonActive" key={ind}>
        <p className="p-0" style={{color:"black",textDecoration:"none",margin:0}} >{pathName}</p>
        {ind !== navBar.length-1 &&<p className="navSlashColor">/</p>}
        </div>
      })
  }
  return (
    <nav>
      <Breadcrumb>
        {renderLinkContainer()}
      </Breadcrumb>
    </nav>
  )
}

export default Nav;